import { exportQrCodes } from "./exportQRCodes/path";

import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/access-codes/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const accessCodes = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  delete: apiPathFunc(pathBase),
  exportQrCodes,
} as const;
